module.exports = __webpack_public_path__ + "static/photo-boost-your-skills-18769a3178e90e59be413abab657bffb.jpg";